import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberFeeForm from '../../../components/forms/MemberFeeForm';
import { useMemberFeeApi } from '../../../hooks/useMemberFeeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { MemberFeeDTO } from '../../../services/apiClient';

const MemberFeeEdit: React.FC = () => {
  const { getById, edit } = useMemberFeeApi();
  const [entityData, setEntityData] = useState<MemberFeeDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Fees', href: '/admin/memberfees' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching MemberFee data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/memberfees');
    } catch (error) {
      console.error('Error updating MemberFee:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberfees"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberFee.Edit'
    >
        {entityData ? (
          <MemberFeeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/memberfees')}
            isLoading={isSubmitting}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default MemberFeeEdit;